module.exports = __webpack_public_path__ + "media/newstyle/images/icon-estantevirtual-823ea3b1270b09bd50f5419b79daf7ef.svg";